var map = {
	"./google-play-badge-da-DK.svg": 42510,
	"./google-play-badge-de-DE.svg": 67980,
	"./google-play-badge-en-GB.svg": 79670,
	"./google-play-badge-en-US.svg": 30893,
	"./google-play-badge-es-ES.svg": 57750,
	"./google-play-badge-es-MX.svg": 39893,
	"./google-play-badge-fr-FR.svg": 56278,
	"./google-play-badge-it-IT.svg": 24500,
	"./google-play-badge-nb-NO.svg": 99851,
	"./google-play-badge-nl-NL.svg": 83026,
	"./google-play-badge-pl-PL.svg": 15850,
	"./google-play-badge-pt-BR.svg": 61078,
	"./google-play-badge-pt-PT.svg": 61770,
	"./google-play-badge-sv-SE.svg": 44759
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31724;